/**
 * The UI language's Stripe Elements locale (TMMRSL-0073): the card's own labels and messages follow
 * the console's language, Portuguese as Brazil's (as `intlLocale`). Kept apart from `stripeSdk.ts`,
 * the only file that names Stripe's SDK package; these values are all Stripe Elements locales.
 */
import type { SupportedLocale } from '@/i18n/constants';

const ELEMENTS_LOCALE = {
  en: 'en',
  es: 'es',
  fr: 'fr',
  pt: 'pt-BR',
} as const satisfies Record<SupportedLocale, string>;

export type ElementsLocale = (typeof ELEMENTS_LOCALE)[SupportedLocale];

export function stripeElementsLocale(locale: SupportedLocale): ElementsLocale {
  return ELEMENTS_LOCALE[locale];
}
